import { atom } from 'recoil';

export const scanListScheduledAtom = atom({
  key: 'scanListScheduledAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});